import { ReportData } from '../types/reportTypes';
import { combineReports } from '../utils/reportAggregationUtils';
import { codySalesJanuary2026Data } from './codySalesJanuary2026Data';
import { codySalesFebruary2026Data } from './codySalesFebruary2026Data';
import { codySalesMarch2026Data } from './codySalesMarch2026Data';

// Q1 2026 Cody Direct Sales Report - aggregates January, February, and March 2026
const allMonthlyReports = [
  codySalesJanuary2026Data,
  codySalesFebruary2026Data,
  codySalesMarch2026Data
];

const combinedData = combineReports(allMonthlyReports, 'Q1 2026 Cody Direct Sales Report');

export const codySalesQ1_2026Data: ReportData = {
  ...combinedData,
  period: {
    month: 1,
    year: 2026,
    quarter: 1,
    startMonth: 1,
    endMonth: 3
  }
};
